// For Announcements and Notifications List
import React, { useEffect, useMemo, useState } from "react";
import Table from "../../components/Table";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import moment from "moment";

import { getAllNewSchemes } from "../../actions/scheme-action-types";
import Icon from "../../components/Icon";
import { CONTENT_TYPES } from "../../constant";
import { Circle } from "../../components/Overlay";
import ConfigData from "../../config/ca-config-json.json";
import { MainPagesPath } from "../../routing/Paths";
import styled from "styled-components";
import SelectInputBox from "../../components/SelectInputBox";
import { Typography } from "@mui/material";
import useGetAllApps from "../../hooks/useGetAllApps";

const { languageOptions, notificationEndType } = ConfigData;

////********Styled Components ********************/
const MainContainer = styled.div`
  padding: 20px 40px;
  overflow: hidden;
  .textTruncate {
    font-family: "Roboto-Regular";
    font-size: 12px;
    color: rgb(81, 83, 83);
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 110px;
  }
`;

const FilterContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const LoaderContainer = styled.div`
  display: flex;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  justify-content: center;
  background-color: rgb(0, 0, 0, 0.3);
  align-items: center;
`;

const AllPromotions = ({ allNewSchemes, getAllSchemes, visible }) => {
  const [tableDataFilter, setTableDataFilter] = useState([]);

  const [selectedApp, setSelectedApp] = useState("");
  const [selectedTenant, setSelectedTenant] = useState("");

  const { tenantList, appList, appInfo } = useGetAllApps();

  const selectedAppData = useMemo(() => {
    return appInfo(selectedApp);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedApp]);

  useEffect(() => {
    const tenant = tenantList[0]?.value;
    setSelectedTenant(tenant);
    setSelectedApp(appList(tenant)?.[0]?.value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenantList]);

  useEffect(() => {
    getAllSchemes({
      tenant: selectedAppData.tenantId,
      appId: selectedAppData.appId,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedApp]);

  const getDocLanguage = (langCode) => {
    try {
      const lang = languageOptions.find((val) => val.value === langCode);
      return lang.label;
    } catch (error) {
      return "";
    }
  };

  const getContentType = (doc) => {
    let contents = [];
    doc?.forEach((item) => {
      if (item.docType === "all") {
        contents = Object.values(CONTENT_TYPES).map((e) => e.label);
      }
      if (item.docType === CONTENT_TYPES.announcement.value) {
        contents.push(CONTENT_TYPES.announcement.label);
      }
      if (item.docType === CONTENT_TYPES.pushNotification.value) {
        contents.push(CONTENT_TYPES.pushNotification.label);
      }
      if (item.docType === CONTENT_TYPES.inAppAlert.value) {
        contents.push(CONTENT_TYPES.inAppAlert.label);
      }
    });
    return contents.join(", ");
  };

  const getMachineModels = (doc) => {
    const models = doc?.slice(0, 5).map((item) => {
      return item.modelNo === "all" ? "All" : item.modelNo;
    });
    return models.join(", ");
  };
  const columns = [
    {
      Header: "Sl No.",
      accessor: "srNo",
      maxWidth: 50,
      style: { textAlign: "center" },
    },
    {
      Header: "Actions",
      accessor: "schemeHdrId",
      headerStyle: { textAlign: "center" },
      style: { textAlign: "center" },
      Cell: (row) => {
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                marginRight: "8px",
                marginLeft: "8px",
                cursor: "pointer",
              }}
            >
              <Link to={`${MainPagesPath.editPromotion}/${row.value}`}>
                <Icon icon="edit" />
              </Link>
            </div>
          </div>
        );
      },
      maxWidth: 80,
    },
    {
      Header: "Status",
      accessor: "isActive",
      maxWidth: 80,
      headerStyle: { textAlign: "center" },
      style: { textAlign: "center" },
      Cell: (row) => {
        return (
          <text
            style={{
              fontFamily: "Roboto-Regular",
              fontSize: "12px",
              color: row.value === 1 ? "#227700" : "#CC0000",
            }}
          >
            {row.value === 1 ? "Active" : "Inactive"}
          </text>
        );
      },
    },
    {
      Header: "Start Date",
      accessor: "startDate",
      maxWidth: 130,
      headerStyle: { textAlign: "center" },
      style: { textAlign: "center" },
    },
    {
      Header: "End Date",
      accessor: "endDate",
      maxWidth: 80,
      headerStyle: { textAlign: "center" },
      style: { textAlign: "center" },
    },
    {
      Header: "Document Name",
      accessor: "documentName",
      maxWidth: 120,
      headerStyle: { textAlign: "center" },
      style: { textAlign: "center" },
    },
    {
      Header: "Description",
      accessor: "documentDesc",
      maxWidth: 200,
      headerStyle: { textAlign: "center" },
      style: { textAlign: "center" },
    },
    {
      Header: "Language",
      accessor: "language",
      maxWidth: 100,
      headerStyle: { textAlign: "center" },
      style: { textAlign: "center" },
      Cell: (row) => {
        return (
          <text
            style={{
              fontFamily: "Roboto-Regular",
              fontSize: "12px",
              color: "#515353",
            }}
          >
            {getDocLanguage(row.row.values.language)}
          </text>
        );
      },
    },

    {
      Header: "Content Type",
      accessor: "schemeVsDocTypeMappingList",
      maxWidth: 120,
      headerStyle: { textAlign: "center" },
      style: { textAlign: "center" },
      Cell: (row) => {
        return (
          <text
            style={{
              fontFamily: "Roboto-Regular",
              fontSize: "12px",
              color: "#515353",
            }}
          >
            {getContentType(row.value)}
          </text>
        );
      },
    },
    {
      Header: "Machine Model",
      accessor: "schemeVsModelMappingList",
      maxWidth: 120,
      headerStyle: { textAlign: "center" },
      style: { textAlign: "center" },
      Cell: (row) => {
        return (
          <text className="textTruncate">{getMachineModels(row.value)}</text>
        );
      },
    },
  ];

  useEffect(() => {
    const tableDataAll =
      allNewSchemes?.map((item, index) => {
        return {
          ...item,
          startDate: item.startDate
            ? moment(item.startDate).format("DD-MMM-YY")
            : item.notificationStartDateTime
              ? moment(item.notificationStartDateTime).format(
                  "DD-MMM-YY hh:mm A"
                )
              : "-",
          endDate: item.endDate
            ? moment(item.endDate).format("DD-MMM-YY")
            : item.endDateType === notificationEndType.onDate.value &&
                item.notificationEndDateTime
              ? moment(item.notificationEndDateTime).format("DD-MMM-YY")
              : "-",
        };
      }) || [];
    setTableDataFilter(tableDataAll);
  }, [allNewSchemes]);

  const tableData = useMemo(() => {
    return (
      tableDataFilter?.map((item, index) => ({
        ...item,
        srNo: index + 1,
      })) || []
    );
  }, [tableDataFilter]);

  return (
    <>
      <MainContainer>
        <Typography
          variant="h5"
          fontWeight={700}
          color={"#003E85"}
          marginBottom={2}
        >
          {"Announcements/Notifications"}
        </Typography>
        <FilterContainer>
          <div>
            <SelectInputBox
              value={selectedTenant}
              options={tenantList}
              label={"Tenant"}
              style={{ width: 200, marginRight: 20 }}
              onChange={(e) => {
                setSelectedTenant(e.target.value);
                setSelectedApp(null);
              }}
            />
            <SelectInputBox
              value={selectedApp}
              options={appList(selectedTenant)}
              label={"App"}
              style={{ width: 200 }}
              onChange={(e) => {
                setSelectedApp(e.target.value);
              }}
            />
          </div>
          <Link
            to={{
              pathname: MainPagesPath.uploadPromotion,
            }}
          >
            <div
              style={{
                backgroundColor: "#003E85",
                padding: "13px",
                paddingLeft: "16px",
                paddingRight: "16px",
                cursor: "pointer",
                display: "flex",
              }}
            >
              <text className={"document-add"}>{"ADD NEW"}</text>
              <Icon icon="addCircle" />
            </div>
          </Link>
        </FilterContainer>
        <Table
          stickyHeader={true}
          columns={columns}
          data={tableData}
          defaultPageSize={10}
          filterSearchTop={"34px"}
          headerZIndex={1}
        />
      </MainContainer>
      {visible && (
        <LoaderContainer>
          <Circle size="Large" />
        </LoaderContainer>
      )}
    </>
  );
};

const mapStateToProps = ({ app: { visible }, schemes: { allNewSchemes } }) => ({
  allNewSchemes,
  visible,
});

export default connect(mapStateToProps, {
  getAllSchemes: getAllNewSchemes,
})(AllPromotions);
